<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style lang="scss" src="@/assets/stylesheets/app.scss"></style>
<style src="@/assets/stylesheets/style.css"></style>


// WEBPACK FOOTER //
// src/App.vue